<template>
  <div>
    <el-row :gutter="20" v-if="isPc">
      <el-col :span="8" v-for="(it, idx) in newsList" :key="idx">
        <div class="news_item" @click="fnToArticle(it.article_id)">
          <el-image :src="it.main_image[0]" fit="cover"></el-image>
          <div class="news_item_info">
            <h3>{{ it.title }}</h3>
            <div class="news_item_time">
              <div>{{ $dayjs(it.publish_time).format("YYYY-MM-DD") }}</div>
              <div class="el-icon-view">{{ it.times }}</div>
            </div>
            <div class="news_item_desc" v-if="it.desctext">
              {{ it.desctext }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <ul class="m-list" v-else>
      <li
        v-for="(item, index) in newsList"
        :key="index"
        class="m-news_item"
        @click="fnToArticle(item.article_id)"
      >
        <el-image :src="item.main_image[0]" fit="cover"></el-image>
        <div class="m-news_item_info">
          <h3>{{ item.title }}</h3>
          <div class="m-news_item_time">
            <div>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</div>
            <!-- <div class="el-icon-view">{{ item.times }}</div> -->
          </div>
          <!-- <div class="news_item_desc" v-if="item.desctext">
                {{ item.desctext }}
              </div> -->
        </div>
      </li>
    </ul>
    <el-button type="info" @click="fnToGetMore()">點擊加載更多</el-button>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      newsListRes: [],
      start: 0,
      limit: 9,
    };
  },
  props: {
    article_type: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isPc"]),
    newsList() {
      return this.newsListRes.map((item) => {
        try {
          if (item.show_type != 0 && item.main_image != 1 && item.main_image) {
            item.main_image = JSON.parse(item.main_image);
            item.main_image = item.main_image.map((img) =>
              !/^http/.test(img) ? this.$imgUrl + img : img
            );
          }
        } catch (e) {}
        return item;
      });
    },
  },
  methods: {
    async getNewsList() {
      let searchJson = {
        article_type: this.article_type,
      };
      if (this.article_type == "XHDT") {
        searchJson.association_id = "SZTX";
      }
      const { data: res } = await this.$http.get("/api/v2/article/list", {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: searchJson,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.newsListRes = [...this.newsListRes, ...res.data];
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToGetMore() {
      this.start += this.limit;
      this.getNewsList();
    },
    fnToArticle(article_id) {
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
  },
  created() {
    this.getNewsList();
  },
};
</script>
<style lang="less" scoped>
.el-button {
  width: 100%;
  font-size: 14px !important;
  color: #878787 !important;
  line-height: 22px !important;
  padding: 10px 0 !important;
  background: #fbfbfb !important;
  border: none !important;
}
.news_item {
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  .el-image {
    width: 100%;
    // height: auto;
    height: 220px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
  .news_item_info {
    padding: 10px 15px 15px;
    height: 93px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: -webkit-fill-available;
    h3 {
      font-size: 22px;
      line-height: 34px;
      margin-bottom: 10px;
      font-family: MicrosoftYaHei;
      color: #222222;
      font-weight: 400;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
      font-family: MicrosoftYaHei;
      color: #888888;
      font-weight: 400;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}
@media screen and (max-width: 768px) {
  .m-list{
    padding: 0 15px;
    background: #fff;
    margin-top: -15px;
    padding-top: 15px;
  }
  .m-news_item {
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    cursor: pointer;
    .el-image {
      width: 114px;
      height: 76px;
      margin-right: 10px;
      border-radius: 4px;
    }
    h3 {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 10px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .m-news_item_info{
      flex: 1;
    }
    .m-news_item_time {
      font-size: 12px;
      color: #888;
      margin-right: 10px;
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
}
</style>
